
const initialState = {
  data: [],
  success: false,
  error: false,
};

export const setRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/SET_REQUEST_REQUEST`: {
      return initialState;
    }
    case `${namespace}/SET_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: true };
    }
    case `${namespace}/SET_REQUEST_FAILURE`: {
      return { ...state, data: action.error, success: false, error: true };
    }
    default:
      return state;
  }
};
